import { service } from '../../../../helpers/http' 

export const ActionGetPlanChargeTypes = ({ dispatch }, payload) => { 
    return service({
        module: 'planChargeType',
        action: 'getPlanChargeTypes',
        payload: payload
    })
}

export const ActionPostPlanChargeTypes = ({ dispatch }, payload) => {

    return service({
        module: 'planChargeType',
        action: 'postPlanChargeTypes',
        payload: payload
    })
    
}

export const ActionPutPlanChargeTypes = ({ dispatch }, payload) => {

    return service({
        module: 'planChargeType',
        action: 'putPlanChargeTypes',
        payload: payload
    })
    
}

export const ActionDeletePlanChargeTypes = ({ dispatch }, payload) => {

    return service({
        module: 'planChargeType',
        action: 'deletePlanChargeTypes',
        payload: payload
    })
    
}
